module.exports = __webpack_public_path__ + "public/Icons/23Cancellationreasons.svg?8c317401";